import { render, staticRenderFns } from "./ProgressBoard.vue?vue&type=template&id=0585ae28&scoped=true&"
import script from "./ProgressBoard.vue?vue&type=script&lang=ts&"
export * from "./ProgressBoard.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBoard.vue?vue&type=style&index=0&id=0585ae28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0585ae28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
